import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class FinancialService extends RLBaseService {

    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getPartyContacts(invoiceID: string) {
        var data = {
            invoiceID: invoiceID
        };
        return this.toRLService<Models.IContactParty>("/api/financial/getpartycontacts/").query(data).$promise;
    }

    removeAmount(relID: string) {
        var data = {
            relID: relID
        };
        return this.toRLService<void>("/api/financial/removeamount").post(data).$promise;
    }

    removeAsset(relID: string) {
        var data = {
            relID: relID
        };
        return this.toRLService<void>("/api/financial/removeasset").post(data).$promise;
    }

    removeContact(relID: string) {
        var data = {
            relID: relID
        };
        return this.toRLService<void>("/api/financial/removecontact").post(data).$promise;
    }

    associateContact(invoiceID: number, contactID: number, partyID: number) {
        var data = {
            invoiceID: invoiceID,
            contactID: contactID,
            partyID: partyID
        };
        return this.toRLService<void>("/api/financial/associatecontact").post(data).$promise;
    }

    deleteInvoice(invoiceID: string) {
        var data = {
            entityID: invoiceID
        };
        return this.toRLService<void>("/api/financial/deleteinvoice").post(data).$promise;
    }

    associateAssets(invoiceID: number, assetIDs: number[]) {
        var data = {
            invoiceID: invoiceID,
            assetIDs: assetIDs
        };
        return this.toRLService<void>("/api/financial/associateassets").post(data).$promise;
    }
}